export function updateSource(source, isoline) {
  const geomFilter = isoline.data
    ? `ST_Intersects(geom, ST_GeogFromGeoJSON('${JSON.stringify(
        isoline.data.geometry
      )}'))`
    : "";

  const extra = geomFilter ? ` WHERE ${geomFilter}` : ` WHERE true`;
  return {
    ...source,
    data: source.data + extra,
  };
}
